import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
interface ImpersonateUserResponse {
  success: boolean;
  message?: string;
  // Add more fields based on the API response structure
  data?: any;
}

interface ImpersonateUserRequest {
  token: string; // Assuming you need a token in the request body
}

export const externalAuthApi = createApi({
  reducerPath: 'externalAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BACKEND_URL, // Ensure this is correct
  }),
  tagTypes: ['ExternalAuth'],
  endpoints: (builder) => ({
    externalLogin: builder.mutation<
      ImpersonateUserResponse,
      ImpersonateUserRequest
    >({
      query: (body) => ({
        url: 'api/user/impersonate-user/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useExternalLoginMutation } = externalAuthApi;
